<template>
   <div class="billing ">
      <BillingForm  />
   </div>
</template>
<script>


import BillingForm from '@/components/BillingForm.vue'
export default {
  name: "Billing",
  components: {
    BillingForm
  }
}
</script>

